import { render, staticRenderFns } from "./BulkUpdateItem.vue?vue&type=template&id=6952314c&scoped=true&"
import script from "./BulkUpdateItem.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6952314c",
  null
  
)

export default component.exports